import axios from "axios";
const state = {
    phases:[]
};
const getters = {};

const actions = {
    getPhases( {commit} ){
        axios
        .get("https://duramaxbackend.unocrm.mx/api/v1/phase/all")
        .then(response => {
            commit('setPhases', response.data);
        });
    }
};

const mutations = {
    setPhases(state, data){
        state.phases = data;
    }
};

export default{
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}